import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "./Footer";
import "./Payment.css";
import {BASE_URL} from "./Constants";

const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const orderId = new URLSearchParams(location.search).get("orderId");

  const [order, setOrder] = useState(null);
  const [shippingDetails, setShippingDetails] = useState(null);

  useEffect(() => {
    if (!orderId) return;
      const fetchOrder = async () => {

      const res = await fetch(`${BASE_URL}/fetch_order/${orderId}`, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        }
      });

      if (!res.ok) return;
      const data = await res.json();

      const subtotal = data.items?.reduce(
        (sum, i) => sum + (i.price || 0) * (i.quantity || 1),
        0
      ) || 0;

      const gstAmount = data.items?.reduce(
        (sum, i) => sum + ((i.price || 0) * (i.gst_percentage || 0) / 100) * (i.quantity || 1),
        0
      ) || 0;

      setOrder({
        ...data,
        subtotal,
        gstAmount,
        total: subtotal + gstAmount
      });
    };
    fetchOrder();
  }, [orderId]);

  useEffect(() => {
    if (!orderId) return;
    const fetchShippingDetails = async () => {

    const res = await fetch(`${BASE_URL}/shipping_details/${orderId}`, {
      method: "GET",
       credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    });
      if (!res.ok) return;
      const data = await res.json();
      if (data && Object.keys(data).length > 0) setShippingDetails(data);
    };

    fetchShippingDetails();
  }, [orderId]);

  if (!order) return <p>Loading order...</p>;

  const safeToFixed = (v) => (typeof v === "number" ? v.toFixed(2) : "0.00");

  const total =
    (order.total || 0) +
    (shippingDetails?.total_cost || 0);

  return (
    <>
      <div className="payment-container">
        <div className="payment-left">
          <div className="logo-name">
            Suyochi Robotics
            {/* <span>Indian online service</span> */}
          </div>
          <div className="price-summary">
            <p>Order ID</p>
            <h2>{order.order_id}</h2>
          </div>
          <div className="price-summary">
            <p>Total Amount</p>
            <h2>₹ {safeToFixed(total)}</h2>
          </div>
          <div className="note">
            <strong>Note:</strong> 
            <p>
              We will review your order details and  share the payment options to the registered email or whatsapp
            </p>
          </div>
        </div>

        <div className="payment-right">
          <div className="payment-header"><h1>Order Summary</h1></div>
          <hr />
          <table className="order-table">
            <thead>
              <tr>
                <th>Title</th><th>Product</th><th>Qty</th>
                <th>Unit Price</th><th>GST %</th><th>GST Amt</th><th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {order.items?.map((item, i) => (
                <tr key={i}>
                  <td>
                    <img
                      src={
                        item.image_id
                          ? `${BASE_URL}/download_image/${item.image_id}`
                          : "/assets/default.jpg"
                      }
                      alt={item.name}
                      style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    />
                  </td>
                  <td
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/Product/${item.item_id}`)}
                    >
                      {item.name || "Unnamed Product"}
                    </td>
                  <td>{item.quantity}</td>
                  <td>₹ {safeToFixed(item.price)}</td>
                  <td>{item.gst_percentage}%</td>
                  <td>₹ {safeToFixed((item.price * item.gst_percentage) / 100)}</td>
                  <td>₹ {safeToFixed(item.price * item.quantity)}</td>
                </tr>
              ))}

              {shippingDetails && (
                <tr>
                  <td>🚚</td>
                  <td>Shipping ({shippingDetails.type})</td>
                  <td>1</td>
                  <td>₹ {safeToFixed(shippingDetails.base_price)}</td>
                  <td>{shippingDetails.gst_percentage}%</td>
                  <td>₹ {safeToFixed(shippingDetails.gst_amount)}</td>
                  <td>₹ {safeToFixed(shippingDetails.total_cost)}</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="total-section">
            <p><strong>Subtotal:</strong> ₹ {safeToFixed(order.subtotal)}</p>
            <p><strong>GST:</strong> ₹ {safeToFixed(order.gstAmount)}</p>
            <p><strong>Shipping:</strong> ₹ {safeToFixed(shippingDetails?.total_cost)}</p>
            <hr />
            <p className="total"><strong>Total:</strong> ₹ {safeToFixed(total)}</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Payment;